import { animate, AnimationEvent, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { interval } from 'rxjs';
import { ComponentBase, AuthService, } from 't4core';
import { MessageModel, MessagePriority } from 't4core';
import { ChangePasswordDialog } from '../../dialogs/changePassword/changePassword';
import { ImpersonateDialog } from '../../dialogs/impersonate/impersonate';
import { WelcomeDialog } from '../../dialogs/welcomeDialog/welcomeDialog';
import { DialogService } from '../../../t4common/';
import { SendMessageDialog } from '../../../apps/messages/dialogs/SendMessageDialog/SendMessageDialog';
import { T4Environment } from 't4core';
import { ConceptModel } from '../../../../projects/t4core/src/public-api';




@Component({
    selector: 't4',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    animations: [
        trigger('menuState', [
            state('expanded', style({
                margin: '0'
            })),
            state('minimized', style({
                margin: '0 0 0 -205px'
            })),
            transition('minimized => expanded', animate('200ms ease-in')),
            transition('expanded => minimized', animate('200ms ease-out'))
        ]),
        trigger('contentState', [
            state('expanded', style({
                width: 'calc(100% - 205px)',
                margin: '0 0 0 205px'
            })),
            state('minimized', style({
                width: '100%',
                margin: '0 0 0 0'
            })),
            transition('minimized => expanded', animate('200ms ease-in')),
            transition('expanded => minimized', animate('200ms ease-out'))
        ]),
        trigger('marquee', [
            state('start', style({
                transform: 'translateX(100%)'
            })),
            state('end', style({
                transform: 'translateX(-100%)'
            })),
            transition('* => end', animate('40s')),
            transition('* => start', animate('0ms'))
        ]),

         trigger('newVersionState', [
            state('true', style({
                 bottom: '0',
            })),
            state('false', style({
                bottom: '-50px',
            })),
            transition('false => true', animate('200ms ease-out')),
            transition('true => false', animate('200ms ease-in'))
        ]),
        trigger('newVersionStateApp', [
            state('false', style({
                height: '100vh',
            })),
            state('true', style({
                height: 'calc(100vh - 50px)',
            })),
            transition('false => true', animate('200ms ease-out')),
            transition('true => false', animate('200ms ease-in'))
        ]),
    ]
})
export class AppComponent extends ComponentBase implements OnInit {
    public loginVisible: Boolean = !this.Settings.isAuthenticated();
    public menuState = "expanded";
    public conceptInfo: ConceptModel;
    public newVersionAvailable: boolean = false;
    public newVersionPopupOpened: moment.Moment = null;
    public currentVersion: string = "";
    private versionChecker: any;

    @ViewChild("pnlFloat", {static: true})
  private floatLayer: ElementRef;
    constructor(private authService: AuthService, private router: Router, private sanitizer: DomSanitizer, private dialog: MatDialog, private renderer: Renderer2, public dialogSvc: DialogService) {
        super();
        this.authService.clearTokens(new Date(2025, 4, 23, 10,0,0));
        this.Api.getVersion().then(x => this.currentVersion = x);

        // Start version checker
        interval(600000).subscribe(async x => {
            if (this.newVersionAvailable) {
                if (!this.newVersionPopupOpened) {
                    this.newVersionPopupOpened = moment();

                    if (await this.UI.confirm("Turbo.App.headConfirmRestart", "There is a newer version of T4 available!", "Turbo.App.msgConfirmRestart", "Do you want to update T4 now?")) {
                        window.location.reload();
                    }

                    this.newVersionPopupOpened = null;
                }
            } else {
                var newVersion = await this.Api.getVersion();
                if (this.currentVersion != newVersion) this.newVersionAvailable = true;
          }

          // Check oneway counting
          if(this.Settings.clientSettings.IsOneWay)
            this.checkOneWayCounting();
        });

        // Start message checker
        interval(60000).subscribe(async x => {
            // Version update in progress?
            if (this.newVersionPopupOpened && this.newVersionPopupOpened < moment().add(-1, 'minute')) {
                window.location.reload();
            }

            if (!this.Settings.isAuthenticated()) return;

            if (Math.random() < 0.05) { this.loadMessages(); }
                
            if (Math.random() < 0.01) { 
                this.Api.get<MessageModel>("Messaging/GetRandom").then(x => {
                  this.messages.push(x);

                    if (this.messages.length == 1 && !this.currentMessage) {
                        this.currentMessage = this.messages.splice(0, 1)[0];
                        if (this.marqueeState == "start") this.marqueeState = "end";
                        else this.marqueeState = "start";
                    }
                });
          }

        });
    }

    public ngOnInit() {
      this.UI.setFloatLayer(this.floatLayer, this.renderer);
    }

    protected authenticationChanged() {
        if (this.Settings.isAuthenticated()) {
            this.loadMessages();
          this.getNextSystemMessage();

          // Check oneway counting
          if (this.Settings.clientSettings.IsOneWay)
            this.checkOneWayCounting();

            //if (!this.Settings.getUser().Impersonating && !this.Settings.getEffectiveUser().IsInitiated)
            //    this.Dialog.open(WelcomeDialog, {
            //        width: '650px',
            //        data: {}
            //    });
        }
    }

    public loginComplete() {
        this.loginVisible = false;
        //this.signalR.start();
        this.router.navigate([window.document.location.pathname]);
  }

  public sendMessage() {
    this.dialogSvc.sendMessage();
    //this.dialog.open(SendMessageDialog, { });
  }

    public logout() {
        this.authService.Logout();
        this.loginVisible = true;
    }

    public async toggleMenu() {
        if (this.menuState == "expanded") this.menuState = "minimized";
        else this.menuState = "expanded";
    }

    public beginChangePassword() {
        let dialogRef = this.dialog.open(ChangePasswordDialog, {
            data: { }
        });

        dialogRef.afterClosed().subscribe(result => { });
    }

  public clearCache() {
    const preserveKey = 'AuthenticationData';
    const preserveValue = localStorage.getItem(preserveKey);

    localStorage.clear();

    if (preserveValue !== null) {
      localStorage.setItem(preserveKey, preserveValue);
    }

    window.location.reload();
  }

  public async clearServerCache() {
    var ret = await this.Api.get<boolean>("/Settings/ClearServerCache");
    if (ret) {
      await this.UI.alert("Turbo.App.Cache.headClearCacheSuccess", "Success", "Turbo.App.Cache.msgClearCacheSuccess", "Server cache is cleared successfully.");
    }
    else {
      await this.UI.alert("Turbo.App.Cache.headClearCacheFailed", "Failed", "Turbo.App.Cache.msgClearCacheFailed", "There seems to be an error clearing the cache. Please try again later.");
    }
  }


    public async resetPassword() {
        if (await this.UI.confirm("Turbo.App.headConfirmResetPassword", "Reset passwords?", "Turbo.App.msgConfirmResetPassword2", "Both Users & Admin passwords will be reset. Continue??")) {
          var token = this.UI.beginLoading("Turbo.App.ldrResetPassword", "Resetting passwords", null);
          if (this.Settings.clientSettings.RentalLocationId) {
            var content = await this.Api.post<any>("/Account/ResetPassword", null, { locationId: this.Settings.clientSettings.RentalLocationId });

            this.UI.loaderCompleted(token);

            await this.UI.alertBox(
              {
                headline: "Turbo.App.headResetPasswordSuccess",
                headlineDefault: "Passwords where reset!",
                message:
                  `Email: ${content.Email} <br>
                <br>
                Username: ${content.Admin.Username} <br> 
                Password: ${content.Admin.Password} <br>
                <br>
                Username: ${content.User.Username} <br> 
                Password: ${content.User.Password} <br>`
              });
          }
          else if (!this.Settings.clientSettings.RentalLocationId && this.Settings.clientSettings.RentalLocationGroupId) {
            var content = await this.Api.post<any>("/Account/ResetGroupPassword", null, { locationId: this.Settings.clientSettings.RentalLocationGroupId });

            this.UI.loaderCompleted(token);

            await this.UI.alertBox(
              {
                headline: "Turbo.App.headResetPasswordSuccess",
                headlineDefault: "Passwords where reset!",
                message:
                `Email: ${content.Email} <br>
                <br>
                Username: ${content.User.Username} <br> 
                Password: ${content.User.Password} <br>`
              });
          }
        }
    }

  public beginImpersonate() {
    if (this.Settings.getUser().Impersonating) {
      this.authService.clearImpersonation();
      this.conceptInfo = null;
    }

    let dialogRef = this.dialog.open(ImpersonateDialog, {
      width: '500px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.Api.get<ConceptModel>("Messaging/GetConceptInfo").then(x => {
        if (x) {
          this.conceptInfo = x;
        }
      });
    });
  }


    /* Mauquee */
    public marqueeState = "start";
    private messages: MessageModel[] = [];
    private currentMessageIndex = -1;
    public currentMessage: MessageModel;

    public MessagePriority = MessagePriority;

    private loadMessages() {
        if (!this.Settings.isAuthenticated()) return;

      this.Api.get<MessageModel[]>("Messaging/GetBannerMessages", { clientVersion: this.currentVersion }).then(x => {
            this.messages = [];
            for(var m of x) this.messages.push(m);

            if (this.messages.length >= 1 && !this.currentMessage) {
                this.currentMessage = this.messages.splice(0, 1)[0];
                this.marqueeState = "end";
            }
        });
    }

    public startMessage(e: AnimationEvent) {
        if (e.toState == "end") {
             
        }        
    }
    public endMessage(e: AnimationEvent) {
        if (e.toState == "end") {
            if (this.currentMessage) {
                if (this.currentMessage.Priority > MessagePriority.Random && this.currentMessage.IsUnread && !this.Settings.getUser().Impersonating) {
                    this.currentMessage.IsUnread = false;

                    this.Api.post("Messaging/RegisterRead?messageId=" + this.currentMessage.Id).then(x => { });
                }

                // Re add the message to the queue?
                if (this.currentMessage.Priority > MessagePriority.Random && (this.currentMessage.ValidThrough == null || this.currentMessage.ValidThrough > moment())) {
                    this.messages.push(this.currentMessage);
                }
            }

            if (this.messages) {
                this.currentMessage = this.messages.splice(0, 1)[0];
                this.marqueeState = "start";
            }
            else this.currentMessage = null;
        } else {
            if(this.currentMessage) this.marqueeState = "end";
        }
  }



    /* System messages */
    public activeSystemMessage: MessageModel | undefined;

    private getNextSystemMessage() {
      this.Api.get<MessageModel>("Messaging/GetNextSystemMessage", { clientVersion: this.currentVersion }).then(x => {
            if (x != undefined)
                this.activeSystemMessage = x;
        });
    }

    public registerResponse() {
        if (this.activeSystemMessage && this.activeSystemMessage.IsUnread && !this.Settings.getUser().Impersonating) {
            this.activeSystemMessage.IsUnread = false;

            this.Api.post("Messaging/RegisterRead?messageId=" + this.activeSystemMessage.Id).then(x => {
                this.getNextSystemMessage();
            });
        }

        this.activeSystemMessage = undefined;
  }

  // OneWay counting
  public async startOneWayCounting() {
    await this.UI.openDialog("T4.OneWay.CountingDialog", { data: { id: this.activeCountingId }, width: '837px', disableClose: true });
    this.checkOneWayCounting();
  }

  public activeCountingId: string;
  public async checkOneWayCounting() {
    if(this.Settings.isInAny(["LocationManager","Clerk"]))
      this.activeCountingId = await this.Api.get<string>("OneWay/GetActiveCounting");
  }

  public async openUserSettings() {
    console.log(this.Settings.getUser());
    await this.UI.openDialog("T4.Settings.EditUser", { width: '900px', data: { user: this.Settings.getEffectiveUser() } });
  }
}

